"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateConsumerPhoneNumberAndNewsLetterStatus = exports.getConsumerIsContractTerminated = exports.getConsumerClientReference = exports.getConsumerDefaultDeliberyPointId = exports.getConsumerContractId = exports.getConsumerState = exports.getConsumer = void 0;
/**
 * Récupère le state du consumer
 * @param {*} store Store redux hébergeant le state
 */
function getConsumer(states) {
    return states.consumer.data;
}
exports.getConsumer = getConsumer;
/**
 * Récupère tout le state du consumer
 * @param states
 */
function getConsumerState(states) {
    return states.consumer;
}
exports.getConsumerState = getConsumerState;
function getConsumerContractId(states) {
    var consumer = getConsumer(states);
    if (consumer) {
        return consumer.defaultContractId;
    }
    return null;
}
exports.getConsumerContractId = getConsumerContractId;
function getConsumerDefaultDeliberyPointId(states) {
    var consumer = getConsumer(states);
    if (consumer) {
        return consumer.defaultDeliveryPointId;
    }
    return null;
}
exports.getConsumerDefaultDeliberyPointId = getConsumerDefaultDeliberyPointId;
/**
 * Récupère tout le state du consumer
 * @param states
 */
function getConsumerClientReference(states) {
    var consumer = getConsumer(states);
    if (consumer) {
        return consumer.clientReference;
    }
    return null;
}
exports.getConsumerClientReference = getConsumerClientReference;
/**
 * Récupère l'info isContractTerminated
 * @param states
 */
function getConsumerIsContractTerminated(states) {
    var consumer = getConsumer(states);
    if (consumer) {
        return consumer.isContractTerminated === true;
    }
    return false;
}
exports.getConsumerIsContractTerminated = getConsumerIsContractTerminated;
/**
 * Récupère la valeur de updateInfoResult
 * @param states
 */
function updateConsumerPhoneNumberAndNewsLetterStatus(states) {
    var consumerState = getConsumerState(states);
    if (consumerState) {
        return consumerState.updatePhoneNewsLetter.updateInfoResult;
    }
    return null;
}
exports.updateConsumerPhoneNumberAndNewsLetterStatus = updateConsumerPhoneNumberAndNewsLetterStatus;
